import React from 'react';

/**
 * Types that render as a public-facing "card" (a data widget the user reads/interacts with),
 * as opposed to inline primitives (Text/Button/Select/Bullets) that flow with the prose.
 * Card-type nodes are wrapped in <InlineCard/> so their chrome + behaviour are UNIFIED.
 */
export const CARD_TYPES = new Set([
  'Table', 'PieChart', 'LineChart', 'BarChart', 'ScatterChart', 'Distribution', 'Artifact',
  'ThesisOnePager', 'ScenarioMatrix',
]);

/**
 * Unified wrapper for every inline UI card in the message stream. Centralizing the chrome here
 * (one container, one set of paddings/borders, dark-mode, and a home for shared behaviours like
 * expand/copy later) means every chart/table/artifact a public-facing agent emits behaves and
 * looks the same — instead of each catalog widget styling itself. Add cross-card behaviour here,
 * not in each widget.
 */
export const InlineCard: React.FC<{ type: string; children: React.ReactNode }> = ({ type, children }) => (
  <div
    data-testid="inline-card"
    data-card-type={type}
    className="my-1.5 max-w-full overflow-hidden rounded-xl border border-secondary-200 dark:border-secondary-700 bg-white dark:bg-secondary-900/40 p-2.5"
  >
    {children}
  </div>
);

export default InlineCard;
